export default class NewsModel {
  /* tslint:disable:variable-name */
  public _id: string
  public title: string
  public type: string
  public url: string
  public created_at: Date
  public updated_at: Date

  constructor() {
    this._id = ''
    this.title = ''
    this.type = ''
    this.url = ''
    this.created_at = new Date()
    this.updated_at = new Date()
  }
}
